import { endOfToday, startOfToday, subMonths } from 'date-fns';

export const getTSForGoalsOneOnOneTasks = () => {
  const endTS = endOfToday().valueOf();
  const startTS = subMonths(startOfToday(), 12).valueOf();
  return {
    startTS,
    endTS,
  };
};
